import React, {Dispatch, SetStateAction} from "react";
import ModalWrapper from "components/UI/Modal/ModalWrapper";

export interface IModal {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export interface IModalProps extends IModal {
    title: string;
    children?: React.ReactNode;
}

const Modal: React.FC<IModalProps> = (
    {
        isOpen,
        setIsOpen,
        title,
        children,
    }
) => {
    return (
        <ModalWrapper isOpen={isOpen} setIsOpen={setIsOpen}>
            <div onClick={(e) => {
                e.stopPropagation()
            }} className="modal__content">
                <button className="modal__btn-close" onClick={() => {setIsOpen(false)}}>Close</button>
                <p className="modal__title">{title}</p>
                {children}
            </div>
        </ModalWrapper>
    );
};

export default Modal;